import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../../../../units/Box/Box';
import Text from '../../../../units/Text/Text';
import ButtonAsync from '../../../../units/ButtonAsync/ButtonAsync';

import FormInput from '../../FormControls/FormInput/FormInput';

import { FormTitle } from '../../FormUnits/FormUnits';

import FormsActions from '../../../../../store/forms/formsActions';
import errorFormConfig from '../../../../../store/forms/formsConfigs/forms/errorFormConfig';
import FormsSelectors from '../../../../../store/forms/utils/formsSelectors';

import withForm from '../../../../hocs/withForm';

const InputWrapper = styled(Box).attrs({
  mb: '20px'
})``;

const FormActions = {
  next: {
    actionId: 'next',
    isActionSubmit: true
  },
  testOrg: {
    actionId: 'testOrg',
    isActionSubmit: true
  }
};

const ErrorText = styled(Text).attrs({
  size: '13px',
  font: 'caption'
})`
  color: ${props => props.theme.colors.error};
`;

class RegistratUserOrgForm extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    errors: PropTypes.array.isRequired,
    instanceToken: PropTypes.string.isRequired,
    modalForms: PropTypes.array.isRequired,
    getFieldProps: PropTypes.func.isRequired,
    getActionProps: PropTypes.func.isRequired,
    applyAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
  };

  componentWillReceiveProps(nextProps) {
    if (
      !this.isJustErrorModalOpened(this.props) &&
      this.isJustErrorModalOpened(nextProps)
    ) {
      FormsActions.updateForm({
        instanceToken: nextProps.instanceToken,
        fields: {},
        actions: {
          [FormActions.next]: {
            isProcessing: false
          }
        }
      });
    }
  }

  isJustErrorModalOpened = ({ getActionProps, modalForms, instanceToken }) => {
    const { isProcessing } = getActionProps(FormActions.next);
    if (!isProcessing) return false;

    const errorModalForm = modalForms.find(({ parentToken, instanceName }) => {
      return (
        instanceName === errorFormConfig.instanceName &&
        parentToken === instanceToken
      );
    });
    return Boolean(errorModalForm);
  };

  findOrganization = async values => {
    await this.props.applyAction({
      actionId: 'next',
      values
    });
  };

  emulateFindOrganization = async values => {
    await this.props.applyAction({
      actionId: 'testOrg',
      values
    });
  };

  renderErrors = () => {
    const { errors, getActionProps } = this.props;

    const error = errors.find(item => item.level === 'CRITICAL_ERROR');

    if (!error || getActionProps(FormActions.next).isProcessing) return null;

    return (
      <Box mb="22px">
        <ErrorText className="errorText">{error.message}</ErrorText>
      </Box>
    );
  };

  render() {
    const { getFieldProps, getActionProps } = this.props;

    const innFieldConfig = getFieldProps('inn');
    const ogrnFieldConfig = getFieldProps('ogrn');

    const nextButtonProps = getActionProps(FormActions.next);
    const testOrgButtonProps = getActionProps(FormActions.testOrg);

    return (
      <Flex align="center" column className="zeroClient_step_orgINN">
        <FormTitle className="form-title_user-org">
          Укажите данные организации
        </FormTitle>

        <Flex align="flex-end" column>
          <Box>
            <InputWrapper>
              <FormInput
                width="400px"
                label="ИНН"
                labelParams={{ spacing: '1px' }}
                {...innFieldConfig}
                disabled={
                  innFieldConfig.disabled || nextButtonProps.isProcessing
                }
              />
            </InputWrapper>

            <InputWrapper>
              <FormInput
                width="400px"
                label="ОГРН / ОГРНИП"
                labelParams={{ spacing: '1px', whiteSpace: 'nowrap' }}
                {...ogrnFieldConfig}
                disabled={
                  ogrnFieldConfig.disabled || nextButtonProps.isProcessing
                }
              />
            </InputWrapper>
          </Box>

          <Box width="400px">
            {this.renderErrors()}

            <Box>
              <Box>
                <ButtonAsync
                  onClick={this.props.handleSubmit(this.findOrganization)}
                  size="large"
                  font="caption"
                  bold
                  {...nextButtonProps}
                >
                  Найти организацию
                </ButtonAsync>
              </Box>
              <Box mt="10px">
                <ButtonAsync
                  onClick={this.props.handleSubmit(
                    this.emulateFindOrganization
                  )}
                  size="large"
                  font="caption"
                  bold
                  {...testOrgButtonProps}
                >
                  hack ИНН
                </ButtonAsync>
              </Box>

              {nextButtonProps.isProcessing && (
                <Box mt="10px">
                  <Text font="caption" size="13px" className="companySearching">
                    Ищем вашу компанию в базе ФНС. Скоро вы сможете продолжить
                    регистрацию…
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
        </Flex>
      </Flex>
    );
  }
}

const RegistratUserOrgFormConnected = connect(state => {
  return {
    modalForms: FormsSelectors.getModalForms(state)
  };
})(RegistratUserOrgForm);

export default withForm(RegistratUserOrgFormConnected);



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/RegistratUserOrg/RegistratUserOrg.js